import { ObjectItem } from '@services';
import { IObjectStringKeyMap } from '@shared/models';

export interface UploadFile {
  data?: File;
  object?: ObjectItem;
  icon: string;
  progress?: number | null;
  preview: string | null;
  status?: UploadFileStatus;
  error?: string;
}

export enum UploadFileStatus {
  Done = 'done',
  Error = 'error'
}

export interface FormFileUploaderConfig {
  limit?: number;
  accept?: string;
  viewOnly?: boolean;
  deferredUpload?: boolean;
  requestRemovingOnAction?: boolean; // works for deferredUpload: true
  metadata: FormFileUploaderMetadata;
}

export interface FormFileUploaderMetadata extends IObjectStringKeyMap<any> {
  type?: string;
  subtype?: string;
  revision?: string;
}

export interface FormFieldUploaderValue {
  objectID?: number;
  objectUUID?: string;
  revision?: string;
}
